export const isPhysicalProduct = (typename) => {
  return ['PhysicalProductCartItem', 'LensesCartItem'].includes(typename)
}

export const isAppointmentProduct = (typename) => {
  return ['AppointmentCartItem', 'AppointmentWithDoctorCartItem'].includes(typename)
}
